import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { OivCoreSharedFacade } from '@mobi/oiv-viewer-utils-ng-jslib';
import { MobiUiMessage, MobiUiMessageItemComponent, MobiUiMessagesComponent } from '@mobi/rwc-ui-components-ng-jslib';

@Component({
    selector: 'oiv-viewer-notification',
    imports: [MobiUiMessagesComponent, MobiUiMessageItemComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.scss',
})
export class AlertComponent {
    #coreSharedFacade = inject(OivCoreSharedFacade);
    notifications = this.#coreSharedFacade.notifications;

    removeMessage(messageForRemoval: MobiUiMessage) {
        this.#coreSharedFacade.removeAlert(messageForRemoval);
    }
}
